<template>
    <v-dialog v-model="visible" persistent width="800px">
        <v-card>
            <v-card-title class="justify-center">
                <v-switch
                    dense
                    inset
                    true-value="ativo"
                    false-value="inativo"
                    hide-details
                    class="pb-2"
                    v-model="form.status"
                    :label="form.status == 'ativo' ? 'Disponível' : 'Indisponível'"
                />
                <v-spacer />
                <span v-if="$vuetify.breakpoint.smAndUp">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Produto
                </span>
                <v-spacer />
                <v-btn color="primary" icon style="rotate: 45deg;" @click="tooglePin">
                    <v-icon>mdi-pin{{ pin ? '' : '-off' }}</v-icon>
                </v-btn>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text
                align="center"
                justify="center"
                :style="`height: ${$vuetify.breakpoint.height - 240}px; overflow-y: auto;`"
            >
                <v-text-field
                    v-if="hasFiscalModule"
                    ref="codigo"
                    label="Código de Barras GTIN"
                    v-model="form.gtin"
                    @keypress.enter="$refs.nome.focus()"
                    v-mask="['##############']"
                    outlined
                    dense
                />
                <v-text-field
                    ref="nome"
                    label="Nome do Produto"
                    v-model="form.descricao"
                    @keypress.enter="$refs.grupo.focus()"
                    outlined
                    dense
                />
                <v-autocomplete
                    ref="grupo"
                    prepend-inner-icon="mdi-magnify"
                    v-model="form.grupo_id"
                    :items="grupos"
                    @keypress.enter="focusNext"
                    dense
                    clearable
                    item-text="descricao"
                    item-value="id"
                    label="Grupo (selecione ou cadastre um novo)"
                    outlined
                >
                    <template #append-item>
                        <div
                            style="font-size: 14px; font-weight: bold; padding: 14px; cursor: pointer;"
                            @click="newGrupo"
                        >
                            <v-icon>mdi-plus</v-icon> Cadastrar novo grupo
                        </div>
                    </template>
                    <template #append>
                        <v-btn
                            @click="newGrupo"
                            small
                            outlined
                        >
                            <v-icon>mdi-plus</v-icon> Novo
                        </v-btn>
                    </template>
                </v-autocomplete>

                <v-textarea
                    ref="detalhes"
                    clearable
                    clear-icon="mdi-backspace-outline"
                    v-model="form.detalhes"
                    label="Detalhes/Ingredientes"
                    outlined
                />

                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            ref="valor"
                            label="Preço"
                            :prefix="moeda()"
                            v-model="form.valor"
                            @keypress.enter="$refs.valorAntigo.focus()"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            ref="valorAntigo"
                            label="Preço antigo"
                            :prefix="moeda()"
                            v-model="form.valor_antigo"
                            @keypress.enter="$refs.valorMin.focus()"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            style="text-decoration: line-through;"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            ref="valorMin"
                            label="Preço à partir de"
                            :prefix="moeda()"
                            v-model="form.valor_minimo"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-row v-if="hasIfoodCatalogo">
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Preço no iFood"
                            :prefix="moeda()"
                            v-model="form.valor_ifood"
                            placeholder="Mesmo preço"
                            hint="Se vazio, usa o preço normal"
                            persistent-hint
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            outlined
                            dense
                        />
                    </v-col>
                </v-row>

                <v-row v-if="!hasFichaTecnica">
                    <v-col cols="12" sm="4">
                        <v-text-field
                            ref="custoSimples"
                            label="Custo"
                            :prefix="moeda()"
                            v-model="form.custo"
                            placeholder="0.00"
                            v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                </v-row>

                <v-expansion-panels v-if="hasFichaTecnica" v-model="custoPanel" flat class="mt-4 custo-panel">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="px-3">
                            <div class="d-flex align-center" style="width: 100%; gap: 8px;">
                                <v-icon color="grey darken-2">mdi-calculator-variant-outline</v-icon>
                                <span class="subtitle-1 font-weight-medium">Custo e ficha técnica</span>
                                <v-chip v-if="hasFicha" x-small>{{ formIngredientes.length }} ingr.</v-chip>
                                <v-spacer />
                                <span v-if="!custoAberto" class="caption grey--text text--darken-1 mr-2">{{ resumoColapsado }}</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content eager>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    ref="custo"
                                    label="Custo"
                                    :prefix="moeda()"
                                    v-model="form.custo"
                                    :readonly="hasFicha"
                                    :hint="hasFicha ? 'Calculado pela ficha técnica' : ''"
                                    :persistent-hint="hasFicha"
                                    placeholder="0.00"
                                    v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                                    outlined
                                    dense
                                    hide-details
                                >
                                    <template v-if="hasFicha" #append>
                                        <v-icon small color="grey" title="Calculado pela ficha técnica">mdi-clipboard-list-outline</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <template v-if="hasFichaTecnica">
                            <v-autocomplete
                                class="mt-4"
                                prepend-inner-icon="mdi-magnify"
                                @change="onIngredienteChange"
                                v-model="ingrediente"
                                :items="ingredientes"
                                return-object
                                :item-text="e => `${e.id} - ${e.nome}`"
                                item-value="id"
                                dense
                                label="Pesquisa Ingredientes"
                                placeholder="Selecione"
                                outlined
                                hide-details
                            >
                                <template #append-item>
                                    <div
                                        style="font-size: 14px; font-weight: bold; padding: 14px; cursor: pointer;"
                                        @click="newIngrediente"
                                    >
                                        <v-icon>mdi-plus</v-icon> Cadastrar novo ingrediente
                                    </div>
                                </template>
                                <template #append>
                                    <v-btn
                                        @click="newIngrediente"
                                        small
                                        outlined
                                    >
                                        <v-icon>mdi-plus</v-icon> Novo
                                    </v-btn>
                                </template>
                            </v-autocomplete>

                            <div class="mt-4">
                                <v-row v-for="(ingrediente, index) in formIngredientes" :key="index" class="item-card" align="center">
                                    <v-col cols="5">
                                        <h4>{{ ingrediente.id }} - {{ ingrediente.nome }} ({{ ingrediente.unidade_medida.abreviacao }})</h4>
                                        <span v-if="!(+ingrediente.custo_unitario)" class="caption orange--text">
                                            <v-icon x-small color="orange">mdi-alert</v-icon> custo não cadastrado
                                        </span>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field
                                            @change="onChangeQtd($event, 'quantidade', index)"
                                            v-model="ingrediente.quantidade"
                                            label="Quantidade"
                                            type="number"
                                            dense
                                            outlined
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="3" class="text-right">
                                        <span class="body-2">{{ formatBRL(subtotalIngrediente(ingrediente)) }}</span>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-btn @click.stop="removeIngrediente(index)" color="red" icon>
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <v-row v-if="formIngredientes.length" class="px-3">
                                    <v-col class="text-right py-2">
                                        <span class="subtitle-2">Custo da ficha: <b>{{ formatBRL(custoFicha) }}</b></span>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>

                        <v-sheet v-if="margemPct !== null" rounded class="mt-3 pa-3" color="grey lighten-4">
                            <div v-if="temSaboresEscalaveis" class="caption grey--text text--darken-1 mb-2 d-flex align-center">
                                <v-icon x-small color="grey" class="mr-1">mdi-information-outline</v-icon>
                                Estimativa: custo da base + média dos sabores × multiplicador. O custo real por venda aparece no pedido.
                            </div>
                            <v-row dense>
                                <v-col cols="4">
                                    <v-card outlined flat class="pa-2" style="height: 100%;">
                                        <div class="caption grey--text text--darken-1 d-flex align-center">
                                            <v-icon x-small class="mr-1">mdi-fire</v-icon> Custo
                                            <v-tooltip bottom max-width="320">
                                                <template #activator="{ on, attrs }">
                                                    <v-icon x-small color="grey" class="ml-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                                </template>
                                                <div style="font-size: 12px; line-height: 1.7;">
                                                    <div class="mb-1"><b>Como o custo estimado é montado</b></div>
                                                    <div>Base (ficha do produto): {{ formatBRL(custoBreakdown.base) }}</div>
                                                    <div v-for="(e, i) in custoBreakdown.etapas" :key="i">
                                                        + {{ e.titulo }}: {{ formatBRL(e.subtotal) }}
                                                        <span style="opacity: .75;">(média {{ formatBRL(e.media) }} de {{ e.qtd }} {{ e.qtd === 1 ? 'sabor' : 'sabores' }} × {{ e.mult }})</span>
                                                    </div>
                                                    <div style="border-top: 1px solid rgba(255,255,255,.3); margin-top: 4px; padding-top: 4px;">
                                                        <b>Total estimado: {{ formatBRL(custoBreakdown.total) }}</b>
                                                    </div>
                                                </div>
                                            </v-tooltip>
                                        </div>
                                        <div class="text-h6 font-weight-medium">{{ formatBRL(custoEstimado) }}</div>
                                        <div class="caption grey--text text--darken-1 d-flex align-center" style="gap: 6px;">
                                            <span v-if="foodCostPct !== null">food cost {{ foodCostPct }}%</span>
                                            <v-tooltip v-if="foodCostPct !== null" bottom max-width="300">
                                                <template #activator="{ on, attrs }">
                                                    <v-chip :color="foodCostColor" x-small label outlined v-bind="attrs" v-on="on" style="cursor: help;">
                                                        {{ foodCostStatusText }}
                                                    </v-chip>
                                                </template>
                                                <div style="font-size: 12px; line-height: 1.7;">
                                                    <div class="mb-1"><b>Food cost</b> — quanto o custo representa do preço de venda. Quanto menor, mais saudável a margem.</div>
                                                    <div>• até 35% — Saudável</div>
                                                    <div>• 35% a 42% — Atenção</div>
                                                    <div>• acima de 42% — Alto</div>
                                                </div>
                                            </v-tooltip>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined flat class="pa-2" style="height: 100%;">
                                        <div class="caption grey--text text--darken-1 d-flex align-center">
                                            <v-icon x-small class="mr-1">mdi-cash</v-icon> Lucro
                                        </div>
                                        <div class="text-h6 font-weight-medium">{{ formatBRL(lucroValor) }}</div>
                                        <div class="caption grey--text text--darken-1">margem {{ margemPct }}%</div>
                                    </v-card>
                                </v-col>
                                <v-col cols="4">
                                    <v-card outlined flat class="pa-2" style="height: 100%;">
                                        <div class="caption grey--text text--darken-1 d-flex align-center">
                                            <v-icon x-small class="mr-1">mdi-tag-outline</v-icon> Preço
                                        </div>
                                        <div class="text-h6 font-weight-medium">{{ formatBRL(form.valor) }}</div>
                                        <div class="caption grey--text text--darken-1">venda</div>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <template v-if="foodCostPct !== null">
                                <div class="d-flex justify-space-between caption grey--text text--darken-1 mt-3 mb-1">
                                    <span>{{ foodCostPct }}% custo</span>
                                    <span>{{ (100 - foodCostPct).toFixed(1) }}% lucro</span>
                                </div>
                                <div class="d-flex" style="height: 12px; border-radius: 6px; overflow: hidden;">
                                    <div :class="foodCostColor" :style="{ width: foodCostPct + '%' }"></div>
                                    <div class="grey lighten-2" :style="{ width: (100 - foodCostPct) + '%' }"></div>
                                </div>
                            </template>
                        </v-sheet>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-select
                    ref="categoriaImposto"
                    v-if="hasFiscalModule && categoriasImposto.length"
                    v-model="form.categoria_imposto_id"
                    :items="categoriasImposto"
                    :item-text="e => `${e.id} | ${e.nome}`"
                    item-value="id"
                    label="Categoria de imposto"
                    class="mt-6"
                    hide-details
                    outlined
                    dense
                />
                <div class="d-flex align-center">
                    <v-switch
                        dense
                        inset
                        class="py-2"
                        hide-details
                        v-model="form.mostra_cardapio"
                        label="Exibir no Cardápio Digital"
                    />
                    <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Controla a exibição deste item no cardápio digital acessado pelo link e QR Code.</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center">
                    <v-switch
                        dense
                        inset
                        class="py-2"
                        hide-details
                        v-model="form.mostra_tablet"
                        label="Exibir no Tablet"
                    />
                    <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Controla a exibição deste item no tablet de mesa, disponível no módulo Tablet de Mesa para autoatendimento.</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center" v-if="hasIfoodCatalogo">
                    <v-switch
                        dense
                        inset
                        class="py-2"
                        hide-details
                        v-model="form.is_pizza"
                        label="É pizza (tamanho)?"
                    />
                    <v-tooltip bottom max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Marque se este produto é um tamanho de pizza (ex: "Pizza Grande"). Produtos de pizza são exportados ao iFood pela tela "Pizza", não como item normal.</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center" v-if="hasIfoodCatalogo">
                    <v-switch
                        dense
                        inset
                        class="py-2"
                        hide-details
                        v-model="form.ifood_sync"
                        label="Sincronizar com iFood"
                    />
                    <v-tooltip bottom max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Quando ligado, alterações neste produto são enviadas automaticamente ao iFood ao salvar. Desligue para gerenciar este item só manualmente.</span>
                    </v-tooltip>
                </div>
                <v-switch
                    v-if="controleEstoqueAtivo()"
                    dense
                    inset
                    class="py-2"
                    hide-details
                    v-model="form.controle_estoque"
                    label="Controlar estoque"
                    outlined
                />
                <v-text-field
                    v-if="controleEstoqueAtivo() && form.controle_estoque"
                    label="Quantidade disponível"
                    v-model="form.estoque"
                    placeholder="0"
                    type="number"
                    outlined
                    dense
                />
                <v-select
                    v-if="controleEstoqueAtivo() && form.controle_estoque"
                    v-model="form.acao_sem_estoque"
                    :items="opcoesAcaoSemEstoque"
                    label="Ao acabar o estoque"
                    outlined
                    dense
                />

                <v-switch
                    v-if="hasFidelidadeModule"
                    dense
                    inset
                    class="py-2"
                    hide-details
                    v-model="form.pontos_ativo"
                    label="Troca por pontos"
                    outlined
                />
                <PontosResgateInput
                    v-if="form.pontos_ativo"
                    v-model="form.pontos_multiplicador"
                    :preco="+form.valor || form.valor_minimo"
                />

                <fieldset class="v-fieldset mt-2 pl-4">
                    <legend class="v-legend">
                        <h3>Etapas do Produto</h3>
                    </legend>

                    <v-autocomplete
                        prepend-inner-icon="mdi-magnify"
                        append-outer-icon="mdi-pencil"
                        @click:append-outer="onClickEditStep"
                        @change="onStepChange"
                        v-model="step"
                        :items="steps"
                        return-object
                        :item-text="rotuloEtapaComCodigo"
                        item-value="id"
                        dense
                        label="Adicionar Etapas"
                        placeholder="Selecione"
                        outlined
                        hide-details
                    >
                        <template #append-item>
                            <div
                                style="font-size: 14px; font-weight: bold; padding: 14px; cursor: pointer;"
                                @click="newStep"
                            >
                                <v-icon>mdi-plus</v-icon> Cadastrar nova etapa
                            </div>
                        </template>
                        <template #append>
                            <v-btn
                                @click="newStep"
                                small
                                outlined
                            >
                                <v-icon>mdi-plus</v-icon> Novo
                            </v-btn>
                        </template>
                    </v-autocomplete>

                    <div v-if="formSteps.length" style="display: flex; margin: 10px 0;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    small
                                    :color="blockDraggable ? '' : 'primary'"
                                    @click="blockDraggable = !blockDraggable"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon :class="{ shake: shakeLockIcon }">
                                        {{ blockDraggable ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>{{ blockDraggable ? 'Desbloquear ordenação' : 'Salvar ordenação' }}</span>
                        </v-tooltip>
                    </div>

                    <draggable
                        v-model="formSteps"
                        :disabled="blockDraggable"
                    >
                        <div v-for="(step, index) in formSteps" :key="index">
                            <v-row class="item-card">
                                <v-col style="max-width: 40px;">
                                    <v-icon
                                        style="cursor: move;"
                                        @mousedown="handleDragIconClick"
                                    >
                                        mdi-drag-vertical
                                    </v-icon>
                                </v-col>
                                <v-col>
                                    <h4 class="d-flex align-center">
                                        {{ step.id }} - {{ rotuloEtapa(step) }}
                                        <v-tooltip bottom max-width="280" v-if="etapaRestrita(step)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon small color="grey" class="ml-1" v-bind="attrs" v-on="on">mdi-eye-off-outline</v-icon>
                                            </template>
                                            <span>{{ textoCanaisEtapa(step) }}</span>
                                        </v-tooltip>
                                    </h4>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        @change="onChangeQtd($event, 'min', index)"
                                        v-model="step.min"
                                        style="width: 80px;"
                                        label="Min"
                                        type="number"
                                        dense
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        @change="onChangeQtd($event, 'max', index)"
                                        v-model="step.max"
                                        style="width: 80px;"
                                        label="Max"
                                        type="number"
                                        dense
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                                <v-col v-if="step.escala_com_tamanho" style="min-width: 130px;">
                                    <v-text-field
                                        v-model="step.multiplicador"
                                        style="width: 120px;"
                                        label="Multiplicador"
                                        type="number"
                                        step="0.1"
                                        placeholder="1"
                                        dense
                                        outlined
                                        hide-details
                                    >
                                        <template #append-outer>
                                            <v-tooltip bottom max-width="300">
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="grey" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                                                </template>
                                                <span>Multiplica os ingredientes desta etapa para este produto/tamanho. 1 = receita cadastrada, 2 = o dobro, 0,5 = metade.</span>
                                            </v-tooltip>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col class="pt-2 d-flex flex-nowrap">
                                    <v-btn @click.stop="editStep(step)" icon title="Editar etapa">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn @click.stop="removeStep(index)" color="red" icon>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </draggable>
                </fieldset>

                <div style="border: solid 1px #999; border-radius: 5px; margin-top: 20px;">
                    <b>Imagem</b>
                    <ImageInput ref="imagem" v-model="form.imagem" :nome-download="form.descricao" />
                </div>

                <h3 class="mt-8">Disponibilidade</h3>

                <v-radio-group
                    v-model="form.disponibilidade.sempre_disponivel"
                    row
                    hide-details
                    style="margin-top: 5px;"
                >
                    <v-radio
                        label="Sempre disponível"
                        :value="true"
                    />
                    <v-radio
                        label="Dias e horários específicos"
                        :value="false"
                    />
                </v-radio-group>

                <div v-if="!form.disponibilidade.sempre_disponivel" class="mt-4">
                    <v-row align="center" v-for="d in form.disponibilidade.programacao" :key="d.diaSemana">
                        <v-switch
                            dense
                            inset
                            hide-details
                            class="mr-2"
                            style="width: 95px;"
                            v-model="d.aberto"
                            :label="d.diaSemana.substr(0, 3)"
                        />
                        <v-text-field
                            v-model="d.horario"
                            hide-details
                            style="max-width: 105px; border: 1px solid #ddd; border-radius: 5px; padding-left: 5px;"
                            v-mask="['##:## - ##:##']"
                            placeholder="00:00 - 00:00"
                            :disabled="!d.aberto"
                        />
                        <v-btn
                            icon
                            small
                            color="primary"
                            v-if="!d.segundoHorarioAtivo"
                            @click="toogleSegundoHorario(d.diaSemana)"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-text-field
                            v-else
                            v-model="d.segundoHorario"
                            hide-details
                            style="max-width: 130px; border: 1px solid #ddd; border-radius: 5px; padding-left: 5px;"
                            v-mask="['##:## - ##:##']"
                            placeholder="00:00 - 00:00"
                            :disabled="!d.aberto"
                        >
                            <template v-slot:append-outer>
                                <v-btn icon x-small @click="toogleSegundoHorario(d.diaSemana)">
                                    <v-icon color="red">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-row>
                </div>

                <div class="mb-12"/>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-btn @click="$emit('close')" color="warning" large text>Cancelar</v-btn>
                <v-spacer />
                <v-btn color="success" large @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>

        <Steps
            :visible="complementosVisible"
            :etapaId="etapaEditando"
            @close="onStepClose"
            @save="fillSteps"
            @delete="deleteStep"
        />

        <CadastroGrupo
            :visible="grupoVisible"
            :formData="formGrupo"
            @onCadastro="onCadastroGrupo"
            @close="closeGrupo"
        />

        <CadastroIngrediente
            :visible="ingredienteVisible"
            :formData="formIngrediente"
            @onCadastro="onCadastroIngrediente"
            @close="closeIngrediente"
        />
    </v-dialog>
</template>

<script>
import { codigoMoeda } from '@/utils/moeda';
import ImageInput from '@/components/ImageInput';
import PontosResgateInput from '@/components/PontosResgateInput';
import Steps from './Steps';
import CadastroGrupo from './Grupo';
import CadastroIngrediente from './Ingrediente';
import draggable from 'vuedraggable';
import { clone } from '@/utils/utils';
import { getTimeErrors } from '@/utils/validate';
import { mapState, mapMutations } from 'vuex';
import { hasModule, hasIfoodCatalogo } from '@/utils/module';
import { rotuloEtapa, rotuloEtapaComCodigo } from '@/utils/etapa';
import { opcoesAcaoItem } from '@/utils/estoque';

export default {
    name: 'Produto',

    components: {
        ImageInput,
        PontosResgateInput,
        Steps,
        CadastroGrupo,
        CadastroIngrediente,
        draggable,
    },

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formData: {
            type: Object,
            default: Object,
        },
    },

    data: () => ({
        innitForm: {
            id: '',
            gtin: null,
            valor: '',
            valor_ifood: '',
            valor_antigo: '',
            valor_minimo: '',
            custo: '',
            detalhes: '',
            grupo_id: '',
            descricao: '',
            imagem: null,
            passos: [],
            ativo: true,
            status: 'ativo',
            mostra_tablet: true,
            mostra_cardapio: true,
            is_pizza: false,
            ifood_sync: true,
            controle_estoque: false,
            estoque: 0,
            acao_sem_estoque: null,
            pontos_ativo: false,
            pontos_multiplicador: false,
            disponibilidade: {
                sempre_disponivel: true,
                programacao: [
                    {isoWeekday: 1, diaSemana: 'SEGUNDA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 2, diaSemana: 'TERCA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 3, diaSemana: 'QUARTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 4, diaSemana: 'QUINTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 5, diaSemana: 'SEXTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 6, diaSemana: 'SÁBADO', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                    {isoWeekday: 7, diaSemana: 'DOMINGO', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
                ],
            },
        },
        form: { disponibilidade: {} },
        formIngredientes: [],
        formSteps: [],
        formGrupo: {},
        formIngrediente: {},
        blockDraggable: true,
        pin: false,
        loading: false,
        grupoVisible: false,
        ingredienteVisible: false,
        complementosVisible: false,
        etapaEditando: null,
        ingrediente: null,
        step: [],
        steps: [],
        grupos: [],
        ingredientes: [],
        categoriasImposto: [],
        dados: [],
        shakeLockIcon: false,
        custoPanel: undefined,
        estoqueCarregado: 0,
    }),

    mounted() {
        this.form = clone(this.innitForm);
        this.pin = localStorage.getItem('pin-cadastro-produtos') === 'true';

        this.fillSteps();
        this.fillGrupos();
        this.fillIngredientes();
        this.fillCategoriasImposto();
    },

    watch: {
        visible(v) {
            if (!v) {
                this.formReset();
                return;
            }

            let dados = this.$store.getters.getData;

            if (dados?.id) {
                this.getById(dados.id, dados.duplicar);
                this.$store.commit('setData', {});
            }

            setTimeout(() => this.$refs.nome.focus(), 100);
        },

        // Com ficha técnica, o custo do produto é dirigido pela ficha (espelha o back).
        custoFicha(val) {
            if (this.hasFicha) {
                this.form.custo = val.toFixed(2);
            }
        },
    },

    computed: {
        ...mapState([
            'configuracoes',
        ]),

        orderedSteps() {
            return this.formSteps?.map((items, index) => ({...items, ...{ordem: index + 1}})) || [];
        },

        opcoesAcaoSemEstoque() {
            return opcoesAcaoItem();
        },

        getGrupos() {
            return this.grupos;
        },

        hasFicha() {
            return this.hasFichaTecnica && !!(this.formIngredientes && this.formIngredientes.length);
        },

        custoFicha() {
            return (this.formIngredientes || []).reduce(
                (s, i) => s + (parseFloat(i.quantidade) || 0) * (parseFloat(i.custo_unitario) || 0),
                0,
            );
        },

        custoEfetivo() {
            return this.hasFicha ? this.custoFicha : (parseFloat(this.form.custo) || 0);
        },

        // Custo médio dos sabores das etapas que escalam, já multiplicado pelo tamanho.
        // Só conta etapas com complementos carregados (produto salvo/recarregado).
        custoSaboresEstimado() {
            return (this.formSteps || []).reduce((total, step) => {
                if (!step.escala_com_tamanho) return total;
                const comps = step.complementos || [];
                if (!comps.length) return total;
                const soma = comps.reduce((s, c) => s + (parseFloat(c.custo) || 0), 0);
                const mult = parseFloat(step.multiplicador) || 1;
                return total + (soma / comps.length) * mult;
            }, 0);
        },

        custoEstimado() {
            return this.custoEfetivo + this.custoSaboresEstimado;
        },

        temSaboresEscalaveis() {
            return this.custoSaboresEstimado > 0;
        },

        // Detalhamento do custo estimado: base (ficha) + sabores por etapa escalável.
        custoBreakdown() {
            const etapas = (this.formSteps || [])
                .filter(s => s.escala_com_tamanho && (s.complementos || []).length)
                .map(s => {
                    const comps = s.complementos || [];
                    const soma = comps.reduce((acc, c) => acc + (parseFloat(c.custo) || 0), 0);
                    const media = soma / comps.length;
                    const mult = parseFloat(s.multiplicador) || 1;
                    return {
                        titulo: s.descricao || s.titulo || 'Etapa',
                        qtd: comps.length,
                        media,
                        mult,
                        subtotal: media * mult,
                    };
                });
            return { base: this.custoEfetivo, etapas, total: this.custoEstimado };
        },

        margemPct() {
            const valor = parseFloat(this.form.valor) || 0;
            if (!valor) return null;
            return ((valor - this.custoEstimado) / valor * 100).toFixed(1);
        },

        foodCostPct() {
            const valor = parseFloat(this.form.valor) || 0;
            if (!valor || !this.custoEstimado) return null;
            return (this.custoEstimado / valor * 100).toFixed(1);
        },

        foodCostColor() {
            const fc = parseFloat(this.foodCostPct);
            return fc <= 35 ? 'success' : (fc <= 42 ? 'warning' : 'error');
        },

        foodCostStatusText() {
            const fc = parseFloat(this.foodCostPct);
            return fc <= 35 ? 'Saudável' : (fc <= 42 ? 'Atenção' : 'Alto');
        },

        lucroValor() {
            const valor = parseFloat(this.form.valor) || 0;
            if (!valor) return null;
            return valor - this.custoEstimado;
        },

        custoAberto() {
            return this.custoPanel === 0;
        },

        resumoColapsado() {
            if (this.custoEstimado > 0) {
                let resumo = (this.temSaboresEscalaveis ? '~' : '') + this.formatBRL(this.custoEstimado);
                if (this.margemPct !== null) {
                    resumo += ` · ${this.margemPct}% margem`;
                }
                return resumo;
            }
            return 'Definir custo';
        },

        hasFiscalModule() {
            return hasModule('FISCAL');
        },

        hasFidelidadeModule() {
            return hasModule('FIDELIDADE');
        },

        hasFichaTecnica() {
            return hasModule('FICHA_TECNICA');
        },

        hasIfoodCatalogo() {
            return hasIfoodCatalogo();
        },

        cssVars() {
            return {
                '--bg-color': '#3874d0',
                '--color': '#fff',
            };
        },
    },

    methods: {
        ...mapMutations({
            setDashboardInitialized: 'setDashboardInitialized',
        }),

        rotuloEtapa,
        rotuloEtapaComCodigo,

        hasSteps(steps) {
            return steps?.length;
        },

        /** Etapa que o cadastro de etapas limitou a alguns canais (ou a nenhum). */
        etapaRestrita(step) {
            return !step.mostra_cardapio || !step.mostra_comanda || !step.mostra_tablet;
        },

        textoCanaisEtapa(step) {
            const canais = [];
            step.mostra_cardapio && canais.push('Cardápio Digital');
            step.mostra_comanda && canais.push('Gestor de Pedidos');
            step.mostra_tablet && canais.push('Tablet');

            return canais.length
                ? `Etapa oferecida só em: ${canais.join(', ')}`
                : 'Etapa desligada em todos os canais';
        },

        fillSteps() {
            this.steps = [];
            this.$http.get('passos').then(resp => {
                this.steps = resp.data.data;
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        getById(id, duplicar = false) {
            this.$root.$emit('loading', true);
            this.$http.get(`produtos/${id}`).then(({ data }) => {
                this.form = data;
                this.estoqueCarregado = data.estoque;
                // Produtos importados do iFood podem vir sem disponibilidade → default
                if (!this.form.disponibilidade || !this.form.disponibilidade.programacao) {
                    this.form.disponibilidade = clone(this.innitForm.disponibilidade);
                }
                this.formSteps = data.passos;
                this.formIngredientes = data.ingredientes;
                this.custoPanel = (this.formIngredientes && this.formIngredientes.length) || parseFloat(this.form.custo) ? 0 : undefined;

                if (duplicar) {
                    this.form.id = null;
                    this.form.ordem = null;
                    this.form.descricao += ' - CÓPIA';
                    this.formSteps.map(e => (e.produto_passo_id = null));
                    this.formIngredientes.map(e => (e.composicao_id = null));
                    this.notify('Produto duplicado');
                }
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            })
            .finally(() => (this.$root.$emit('loading', false)));
        },

        fillGrupos(grupo = null) {
            this.grupos = [];
            this.$http.get('grupos').then(resp => {
                this.grupos = resp.data.data;
                grupo && (this.form.grupo_id = grupo);
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        formatBRL(n) {
            return (parseFloat(n) || 0).toLocaleString('pt-br', { style: 'currency', currency: codigoMoeda() });
        },

        subtotalIngrediente(ingrediente) {
            return (parseFloat(ingrediente.quantidade) || 0) * (parseFloat(ingrediente.custo_unitario) || 0);
        },

        fillIngredientes() {
            this.ingredientes = [];
            this.$http.get('ingredientes').then(resp => {
                this.ingredientes = resp.data.data;
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        async fillCategoriasImposto() {
            if (!this.hasFiscalModule) {
                return;
            }
            const { data } = await this.$http.get('categorias-imposto');
            this.categoriasImposto = data.data;
        },

        newStep() {
            this.complementosVisible = true;
        },

        onClickEditStep() {
            this.complementosVisible = true;
        },

        /** Abre o cadastro de etapas já com esta etapa expandida. */
        editStep(step) {
            this.etapaEditando = step.id;
            this.complementosVisible = true;
        },

        onStepClose() {
            this.complementosVisible = false;
            this.etapaEditando = null;
        },

        deleteStep(id) {
            this.steps = this.steps.filter(e => e.id !== id);
            this.formSteps = this.formSteps.filter(e => e.id !== id);
        },

        onChangeQtd(value, field, index) {
            this.formSteps[index][field] = value;
        },

        onStepChange(passo) {
            if (!this.formSteps) {
                this.formSteps = [];
            }

            this.formSteps.push({
                produto_passo_id: null,
                ordem: this.formSteps.length + 1,
                id: passo.id,
                descricao: passo.descricao,
                identificacao: passo.identificacao,
                escala_com_tamanho: passo.escala_com_tamanho,
                mostra_cardapio: passo.mostra_cardapio,
                mostra_comanda: passo.mostra_comanda,
                mostra_tablet: passo.mostra_tablet,
                multiplicador: 1,
                max: '',
                min: '',
            });

            this.step = [];
        },

        async removeStep(index) {
            if (!await this.$root.$confirm('Confirmação', 'Deseja desvincular a etapa?', { color: 'red darken-1' })) {
                return;
            }
            this.formSteps.splice(index, 1);
        },

        newGrupo() {
            this.formGrupo = { ativo: true, status: 'ativo', mostra_tablet: true, mostra_cardapio: true };
            this.grupoVisible = true;
        },

        onCadastroGrupo(grupo = null) {
            this.grupoVisible = false;
            this.fillGrupos(grupo);
            this.$emit('newGrupo');
        },

        closeGrupo() {
            this.grupoVisible = false;
        },

        newIngrediente() {
            this.formIngrediente = { status: 'ativo' };
            this.ingredienteVisible = true;
        },

        onIngredienteChange(ingrediente) {
            console.log(ingrediente)
            if (!this.formIngredientes) {
                this.formIngredientes = [];
            }

            this.formIngredientes.push({
                composicao_id: null,
                // id: ingrediente.id,
                // nome: ingrediente.descricao,
                quantidade: null,
                ...ingrediente,
            });

            this.ingrediente = [];
        },

        onCadastroIngrediente() {
            this.ingredienteVisible = false;
            this.fillIngredientes();
            this.$emit('newIngrediente');
        },

        async removeIngrediente(index) {
            if (!await this.$root.$confirm('Confirmação', 'Deseja desvincular o ingrediente?', { color: 'red darken-1' })) {
                return;
            }
            this.formIngredientes.splice(index, 1);
        },

        closeIngrediente() {
            this.ingredienteVisible = false;
        },

        tooglePin() {
            this.pin = !this.pin;
            localStorage.setItem('pin-cadastro-produtos', this.pin);
        },

        salvar() {
            const id = this.form.id;

            this.form.passos = this.orderedSteps;
            this.form.ingredientes = this.formIngredientes;

            if (!this.form.descricao) {
                this.notify('Informe o nome do produto', 'warning');
                return;
            }

            if (!this.form.grupo_id) {
                this.notify('Informe o grupo', 'warning');
                return;
            }

            if (this.form.valor === '') {
                this.notify('Informe o preço', 'warning');
                return;
            }

            if (this.form.valor_antigo && +this.form.valor > +this.form.valor_antigo) {
                this.notify('Preço antigo não pode ser maior que o preço atual', 'warning');
                return;
            }

            const estoqueAlterado = `${this.form.estoque}` !== `${this.estoqueCarregado}`;

            if (this.controleEstoqueAtivo() && this.form.controle_estoque
                && +this.form.estoque < 0 && estoqueAlterado) {
                this.notify('Estoque não pode ser negativo', 'warning');
                return;
            }

            if (this.form.pontos_ativo && +this.form.pontos_multiplicador < 1) {
                this.notify('O multiplicador de pontos precisa ser 1 ou maior', 'warning');
                return;
            }

            if (this.hasFiscalModule && this.categoriasImposto.length && !this.form.categoria_imposto_id) {
                this.notify('Informe a categoria de imposto', 'warning');
                return;
            }

            const timeError = getTimeErrors(this.form.disponibilidade.programacao);

            if (timeError) {
                this.notify(timeError, 'warning');
                return;
            }

            const invalidStep = this.form.passos.find(p => p.min === '' || p.max === '');

            if (invalidStep) {
                this.notify(`Informe o valor Min e Max da etapa "${rotuloEtapa(invalidStep)}"`, 'warning');
                return;
            }

            if (id) {
                this.loading = true;
                this.$http.put(`produtos/${id}`, this.form).then(() => {
                    this.$emit('onCadastro', this.form.id);
                    this.setDashboardInitialized(false);
                    this.notify('Atualizado com sucesso!');
                    this.formReset();

                    if (this.pin) {
                        return;
                    }

                    this.$emit('close');
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.loading = false));
                return;
            }

            this.loading = true;
            this.$http.post('produtos', this.form).then(resp => {
                this.$emit('onCadastro', resp.data.data);
                this.setDashboardInitialized(false);
                this.notify('Atualizado com sucesso!');
                this.formReset();

                if (this.pin) {
                    return;
                }

                this.$emit('close');
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loading = false));
        },

        focusNext() {
            this.$refs.grupo.blur();
            this.$refs.detalhes.focus();
        },

        formReset() {
            this.form = clone(this.innitForm);
            this.estoqueCarregado = this.innitForm.estoque;
            this.formIngredientes = [];
            this.formSteps = [];
            this.formGrupo = {};
        },

        toogleSegundoHorario(diaSemana) {
            const programacao = this.form.disponibilidade.programacao.find(f => f.diaSemana == diaSemana);
            programacao.segundoHorarioAtivo = !programacao.segundoHorarioAtivo;
            this.$forceUpdate();
        },

        handleDragIconClick() {
            if (this.blockDraggable) {
                this.shakeLockIcon = true;
                setTimeout(() => {
                    this.shakeLockIcon = false;
                }, 600);
            }
        }
    },
}
</script>

<style scoped>
.v-card {
    padding: 0 15px 0 15px;
}

.col {
    padding: 0;
}

.v-btn--active {
    background-color: var(--bg-color) !important;
    color: var(--color) !important;
}

.item-card {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin: 0 0px 10px 0px;
    padding: 8px 0;
}

@keyframes shake {
  0% { transform: translateX(0); }
  20% { transform: translateX(-5px); }
  40% { transform: translateX(5px); }
  60% { transform: translateX(-5px); }
  80% { transform: translateX(5px); }
  100% { transform: translateX(0); }
}

.shake {
  animation: shake 0.4s ease;
}

.v-fieldset {
    border-color: #fff;
    border-radius: 5px;
    padding: 8px 8px 20px 8px;
}

.v-legend {
    color: #707070;
}

.custo-panel {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
}

.custo-panel ::v-deep .v-expansion-panel-header {
    min-height: 52px;
}

.custo-panel ::v-deep .v-expansion-panel--active > .v-expansion-panel-header {
    border-bottom: 1px solid #eee;
}

.v-card__text {
    padding-top: 20px !important;
}

@media (max-width: 480px) {
    ::v-deep .v-card__text {
        padding: 20px 6px 8px !important;
    }
}
</style>
